import { render } from "./hezuoliucheng.vue?vue&type=template&id=995c3bca"
import script from "./hezuoliucheng.vue?vue&type=script&lang=js"
export * from "./hezuoliucheng.vue?vue&type=script&lang=js"

import "./hezuoliucheng.vue?vue&type=style&index=0&id=995c3bca&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__